import React from "react";
import { Link } from "react-router-dom";
import introductionImg from "../../../assets/images/introduction.jpg";

const Introduction: React.FC = () => {
  return (
    <>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .intro-1 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.05s both; }
        .intro-2 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.15s both; }
        .intro-3 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.25s both; }
        .intro-4 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.35s both; }
      `}</style>

      <div className="bg-white rounded-xl overflow-hidden shadow-[0_2px_20px_rgba(0,0,0,0.08)] max-w-[960px] mx-auto">
        <div className="relative overflow-hidden rounded-t-xl pb-[52px]">
          <div
            className="relative overflow-hidden shadow-[0_20px_40px_rgba(0,0,0,0.07)]"
            style={{
              marginTop: "-78%",
              paddingTop: "100%",
              borderRadius: "50% / 15%",
            }}
          >
            <img
              src={introductionImg}
              alt="Team members"
              className="absolute left-0 right-0 w-full opacity-90"
              style={{ bottom: "-7.5%" }}
            />
          </div>
        </div>

        <div className="text-center px-6 sm:px-10">
          <h2
            className="intro-1 font-bold text-dark-blue font-primary mt-10 mb-3"
            style={{ fontSize: "clamp(22px, 3vw, 30px)" }}
          >
            First things first
          </h2>

          <p
            className="intro-2 text-meta font-primary leading-relaxed mx-auto mb-8"
            style={{ fontSize: "clamp(14px, 1.4vw, 16px)", maxWidth: 580 }}
          >
            Winning teams build trust quickly by helping team members feel
            welcome and by leveraging one another's strengths. The
            Team Trust Accelerator survey starts you and your team on a pathway to better
            results, faster and easier.
          </p>

          <div className="intro-3 mb-8">
            <Link
              to="/begin-survey"
              className="btn btn-normal block w-full max-w-[380px] mx-auto py-[17px] text-[17px]"
            >
              Start the survey
            </Link>
          </div>
        </div>

        {/* <div className="intro-4 flex items-center gap-3 px-7 pt-8 pb-7">
          <TimerIcon />
          <p className="text-meta font-primary text-sm m-0 leading-snug">
            Expected Time to take survey:{" "}
            <strong className="text-dark-blue font-semibold">15 minutes</strong>
          </p>
        </div> */}
      </div>
    </>
  );
};

export default Introduction;
